<div class="w-full h-full flex flex-col">
  <!-- Header -->
  <div class="flex items-center justify-between mb-4">
    <h3 *ngIf="title" class="text-xs font-semibold text-westetics-neutral-600">{{ title }}</h3>
    <div *ngIf="total > 0" class="flex items-center gap-2">
      <span class="text-sm text-westetics-neutral-600">Total:</span>
      <span class="text-sm font-bold text-westetics-neutral-600">{{ formatValue(total) }}</span>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="processedData.length === 0" class="flex-1 flex items-center justify-center">
    <div class="text-center py-8">
      <svg class="w-16 h-16 mx-auto text-gray-300 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" 
          d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
      <p class="text-gray-500">Sem dados para exibir</p>
    </div>
  </div>

  <!-- Ranking List -->
  <div *ngIf="processedData.length > 0" class="flex-1 space-y-3 overflow-y-auto pr-1">
    <div 
      *ngFor="let item of processedData; let i = index"
      class="group relative"
      [class.animate-slideIn]="animated"
      [style.animation-delay]="animated ? (i * 0.05) + 's' : '0s'"
    >
      <!-- Item Container -->
      <div class="relative rounded-xl overflow-hidden transition-all duration-200 hover:shadow-md"
           [ngClass]="i === 0 ? 'bg-westetics-purple-800 text-white' : 'bg-westetics-gray-100 text-westetics-neutral-900'">

        <!-- Progress Bar Background -->
        <div 
          class="absolute inset-0 rounded-xl transition-all duration-700 ease-out"
        ></div>

        <!-- Content -->
        <div class="relative flex items-center justify-between p-3 min-h-[52px]">
          <!-- Left side: Rank + Name -->
          <div class="flex items-center gap-3 flex-1 min-w-0">
            <!-- Rank Badge -->
            <div class="flex-shrink-0 w-6 h-6 rounded-lg flex items-center justify-center font-bold text-sm"
                  [ngClass]="i === 0 ? 'bg-westetics-purple-600' : 'bg-westetics-gray-200'"
                 [style.color]="item.color">
              <span [ngClass]="i === 0 ? 'text-sm text-white' : 'text-sm text-westetics-purple-800'">{{ getRankIcon(item.rank) }}</span>
            </div>

            <!-- Name -->
            <span class="font-medium truncate"
                  [ngClass]="i === 0 ? 'text-sm text-white' : 'text-sm text-westetics-purple-800'"
                  [title]="item.name">
              {{ item.name }}
            </span>
          </div>

          <!-- Right side: Value + Percentage -->
          <div class="flex items-center gap-3 flex-shrink-0 ml-3">
            <span class="font-bold text-base"
                  [ngClass]="i === 0 ? 'text-sm text-white' : 'text-sm text-westetics-purple-800'">
              {{ formatValue(item.value) }}
            </span>
            <span *ngIf="showPercentage" 
                  class="text-xs font-semibold px-[10px] py-[5px] rounded-md shadow-sm"
                  [ngClass]="i === 0 ? 'text-sm text-white' : 'text-sm text-westetics-purple-800'"
                  [ngClass]="i === 0 ? 'bg-westetics-purple-600' : 'bg-westetics-gray-200'"
                  >
              {{ formatPercentage(item.percentage) }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer Legend -->
  <div *ngIf="processedData.length > 0 && data.length > maxItems" class="mt-4 pt-3 border-t border-gray-100">
    <p class="text-xs text-gray-400 text-center">
      Exibindo top {{ maxItems }} de {{ data.length }} itens
    </p>
  </div>
</div>
